export default {
  your_order_is_complete: "ご注文が完了しました",
  the_order_procedure_is_complete: "ご注文の手続きが完了いたしました。ありがとうございます。",
  please_wait_for_a_while_until_the_product_arrives: "注文受付メール、商品出荷mail等をご確認いただき、商品到着までお待ちください。 ",
  check_purchase_history: "購入履歴を確認する",
  return_to_artist_top: "アーティストトップへ戻る"
}